<template>
  <div class="modal">
    <button
      class="modal__close"
      data-cy="close-modal-button"
      @click="$emit('close')"
    >
      <fa icon="times-circle" type="far" />
    </button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Modal",

  mounted() {
    document.addEventListener("keyup", this.escKeyListener);
  },

  beforeUnmount() {
    document.removeEventListener("keyup", this.escKeyListener);
  },

  methods: {
    escKeyListener(evt) {
      const ESC_KEY_CODE = 27;
      if (evt.keyCode === ESC_KEY_CODE) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: $black;
  color: $white;
}

.modal__close {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 30px;
  height: 30px;
  border: none;
  background: none;
  color: white;

  &:hover {
    color: lightgrey;
  }
}
</style>
